<template>
    <div class="auth-layout">
      <router-view />
      <!-- 内容显示在这里 -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'AuthLayout',
  };
  </script>
  
  <style scoped>
  .auth-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  </style>
  